import { render, staticRenderFns } from "./ServicesReservationsCards.vue?vue&type=template&id=4cc6c03c&"
import script from "./ServicesReservationsCards.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports